<div class="pep-selection-step">
  <p class="main-question">
    <strong>¿Eres o tienes vinculos con una Persona Expuesta Politicamente?</strong>
  </p>
  <p class="subtext">
    Selecciona la opcion que corresponda a tu situacion actual o la de tus familiares cercanos.
  </p>

  <!-- Opciones de seleccion -->
  <div class="pep-options">
    <!-- Opcion 1: Sin vinculos -->
    <button
      type="button"
      class="pep-option"
      [class.selected]="selectedOption === 'no-pep'"
      (click)="selectOption('no-pep')"
      [disabled]="loading"
    >
      <div class="option-icon no-pep-icon">
        <mat-icon>person_outline</mat-icon>
      </div>
      <div class="option-content">
        <span class="option-title">No tengo vinculos politicos</span>
        <span class="option-desc">
          Declaro que ni yo ni mis familiares cercanos (hasta 2do grado de consanguinidad)
          ocupamos o hemos ocupado cargos politicos relevantes.
        </span>
      </div>
      <div class="checkmark" *ngIf="selectedOption === 'no-pep'">
        <mat-icon>check_circle</mat-icon>
      </div>
    </button>

    <!-- Opcion 2: Con vinculos -->
    <button
      type="button"
      class="pep-option"
      [class.selected]="selectedOption === 'is-pep'"
      (click)="selectOption('is-pep')"
      [disabled]="loading"
    >
      <div class="option-icon is-pep-icon">
        <mat-icon>account_balance</mat-icon>
      </div>
      <div class="option-content">
        <span class="option-title">Tengo vinculos politicos</span>
        <span class="option-desc">
          Yo o un familiar cercano (conyuge, padres, hijos, hermanos, abuelos, nietos)
          ocupamos o hemos ocupado cargos politicos de alta relevancia.
        </span>
      </div>
      <div class="checkmark" *ngIf="selectedOption === 'is-pep'">
        <mat-icon>check_circle</mat-icon>
      </div>
    </button>
  </div>

  <!-- Informacion adicional: colapsada por defecto para que la pregunta y las dos
       opciones entren en pantalla sin scroll. Quien no sabe que es un PEP la abre. -->
  <div class="info-box" [class.expanded]="showPepInfo">
    <button
      type="button"
      class="info-header"
      (click)="showPepInfo = !showPepInfo"
      [attr.aria-expanded]="showPepInfo"
      aria-controls="pep-info-content"
    >
      <mat-icon class="info-icon">info</mat-icon>
      <span class="info-title">¿Que es una Persona Expuesta Politicamente (PEP)?</span>
      <mat-icon class="chevron">
        {{ showPepInfo ? 'expand_less' : 'expand_more' }}
      </mat-icon>
    </button>

    <div class="info-content" id="pep-info-content" *ngIf="showPepInfo">
      <p class="info-text">
        Son personas que desempenan o han desempenado funciones publicas destacadas, como:
        Presidente, Senadores, Diputados, Ministros de Estado, Jueces de altas cortes,
        Comandantes de Fuerzas Armadas, Directores de empresas publicas, entre otros.
      </p>
      <p class="info-text info-note">
        Incluye a familiares cercanos y socios comerciales de estas personas.
      </p>
    </div>
  </div>

  <!-- Acciones -->
  <div class="actions">
    <button
      type="button"
      class="continue-btn"
      (click)="continue()"
      [disabled]="!selectedOption || loading"
    >
      {{ loading ? 'Procesando...' : 'Continuar' }}
    </button>
    <button
      type="button"
      class="back-btn"
      (click)="goBack()"
      [disabled]="loading"
    >
      Volver
    </button>
  </div>
</div>
